import React from 'react'
import LoanInfo from '../lenders/views/Loan/Info'
import { Link } from '@reach/router'

const finderKeyMap: { [index: string]: string } = {
  'Fixed repayment': 'fixed_loan_agreement',
  'Equity repayment': 'equity_loan_agreement'
}
const docFinderFor = (key: string) => {
  return (doc: any) => doc.name === finderKeyMap[key]
}

export default function LoansList(props: any) {
  let loans = props.loans
  let loanDocs = props.loanDocs
  if (!loans) return null
  let equityLoan =
    loans && loans.find((loan: any) => loan.principal_repayment_type == 'Equity repayment')
  let fixedLoan =
    loans && loans.find((loan: any) => loan.principal_repayment_type == 'Fixed repayment')
  return (
    <React.Fragment>
      <div className="Section  -mod-margin-bottom-7 -mod-margin-top-7">
        <h2 className="Heading -two -underline">Equity loan</h2>
        <ul className="Columns -two -mod-margin-top -mod-margin-bottom">
          {loans?.filter((loan: any) => !loan.principal_repayment_type.toLowerCase().includes('fixed')).map((loan: any) => {
            return (
              <li className="" key={loan.reference}>
                <LoanInfo
                  loan={loan}
                />
                <a href="/accounts/signup-lender/" className="Button -secondary -mod-margin-top">
                  Invest in the {loan.principal_repayment_type.split(' ')[0]} loan
                </a>
              </li>
            )
          })}
        </ul>
      </div>
    </React.Fragment>
  )
}
